module.exports = __webpack_public_path__ + "img/thumbfurniture1.cd025ef5.png";